export enum ImportType {
  IMPORT_TYPE_CARD_ORDERING = 'CARD_ORDERING',
  IMPORT_TYPE_INVENTORY = 'INVENTORY',
  IMPORT_TYPE_SHIPMENT = 'SHIPMENT',
  IMPORT_TYPE_RETAILER = 'RETAILER',
  IMPORT_TYPE_ITEM = 'ITEM',
  IMPORT_TYPE_ITEM_PREPAIRED = 'ITEM_PREPAIRED'
}
